import styled from 'styled-components';
import { typography } from '@clds/typography';
import { Reload } from '@clds/icon';

export const StyledErrorRefresh = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  height: 100%;
  ${typography.xs.regular};
  padding: 25px 0;

  strong {
    color: ${(props) => props.theme.palette.primary};
    cursor: pointer;
  }
`;

export const StyledRefreshIcon = styled(Reload)`
  margin-bottom: ${(props) => props.theme.spacing.md};
`;
